// extracted by mini-css-extract-plugin
export default {"generalLink":"PrivacyPolicy_generalLink__2rMr5","privacyPolicyDiv":"PrivacyPolicy_privacyPolicyDiv__wrG9h"};